export function parseMaskedBuyIn(
  value: string | null | undefined
): number | null {
  if (value === null || value === undefined) {
    return null;
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }

  const parsed = Number(trimmed.replace(/\./g, "").replace(/,/g, "."));
  if (!Number.isFinite(parsed) || parsed < 0) {
    return null;
  }

  return parsed;
}

export class SearchFilters {
  name: string;
  site: Array<any>;
  date: string;
  registerFrom: any;
  buyIn: string;

  validate(): boolean {
    let valid = true;

    if (!this.site?.length) {
      valid = false;
    }

    if (!this.date && !this.name) {
      valid = false;
    }

    if (!this.registerFrom && !this.name) {
      valid = false;
    }

    if (parseMaskedBuyIn(this.buyIn) == null && !this.name) {
      valid = false;
    }

    return valid;
  }
}
